// extracted by mini-css-extract-plugin
export var fadeInOut = "_o-3";
export var icon = "_o-4";
export var savedIndicator = "_o-2";
export var savingIndicator = "_o-0";
export var spin = "_o-1";